import React, { useEffect, useState } from 'react'
import { Card, Col, Container, Image, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { HiLocationMarker } from 'react-icons/hi';
import { ImUsers } from 'react-icons/im';
import { FaUsers } from 'react-icons/fa';
import { GrDocumentVerified } from 'react-icons/gr';
import { FaBuilding } from 'react-icons/fa';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import CountUp from 'react-countup';
import Clients from './Clients';
import Loader from '../components/Loader/Loader';
export default function About() {
    const [loader, setLoader] = useState(true);
    useEffect(()=>{
setTimeout(()=>{
setLoader(false);
},2000);
},[])
    return (
        <>
        {
            loader && <Loader />
        }
            <section className='banner_strip'>
            <h1>About</h1>
            </section>
            <div className='job-page about-page'>
            <Container fluid style={{padding:0}}>
            <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">About</li>
            </ol>
            </nav>
            </Container>
            <section className='section-2 section'>
                    <Container fluid>
                        <Row>
                            <Col lg={6}>
                                <div className='solution-box'>
                                    <h5 className='sub-heading'>Service apprenticeshipwale </h5>
                                    <h1 className='title-heading'>
                                        Dedicated Solutions with
                                        25 Years Experience
                                    </h1>
                                    <p>Entrepreneurs, artist, athletes and other individuals who have excelled in their field share fun and inspiring stories from their journey to success.</p>
                                    <ul>

                                        <li>
                                            <img src={require('../assets/images/icon3.png')} alt="icon3" />
                                        </li>
                                        <li>
                                            <img src={require('../assets/images/icon4.png')} alt="icon4" />
                                        </li>
                                        <li>
                                            <img src={require('../assets/images/icon5.png')} alt="icon5" />
                                        </li>
                                    </ul>
                                    {/* <a href="#" className='kn_btn'>Know More</a> */}
                                </div>
                            </Col>
                            <Col lg={6}>
                                <div className='right-img-box'>
                                    <div className='img-b'>
                                        <img src={require('../assets/images/img1.jpg')} alt="img1" />
                                    </div>
                                    <div className='img-b'>
                                        <img src={require('../assets/images/img.jpg')} alt="img" />
                                    </div>

                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <div className='section-page-two'>
                    <Container fluid>
                       <Row>
                          <Col lg={3} md={3} sm={6} xs={6}>
                            <div className='counter-box'>
                            <CountUp delay={2} end={100} enableScrollSpy={true} scrollSpyOnce={true} />
                             <h4>JOBS</h4>
                             <p>
                                <ImUsers />
                             </p>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={6} xs={6}>
                            <div className='counter-box'>
                            <CountUp delay={2} end={100} enableScrollSpy={true} scrollSpyOnce={true} />
                             <h4>APPLICATIONS</h4>
                             <p>
                                <GrDocumentVerified />
                             </p>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={6} xs={6}>
                            <div className='counter-box'>
                            <CountUp delay={2} end={100} enableScrollSpy={true} scrollSpyOnce={true} />
                             <h4>COMPANIES</h4>
                             <p>
                                <FaBuilding />
                             </p>
                            </div>
                          </Col>
                          <Col lg={3} md={3} sm={6} xs={6}>
                            <div className='counter-box'>
                            <CountUp delay={2} end={100} enableScrollSpy={true} scrollSpyOnce={true} />
                             <h4>EMPLOYERS</h4>
                             <p>
                                <FaUsers />
                             </p>
                            </div>
                          </Col>
                       </Row>
                    </Container>
                </div>

            </div>
            <Clients />
        </>
    )
}
